<template>
  <div
    class="text-body-2"
    data-qa="lpu_partners"
  >
    <div class="mb-2">
      Данные предоставили клиники:
    </div>
    <ul
      class="lpu-partners__list d-flex flex-column gr-1 pa-0 ma-0"
      data-qa="lpu_partners_list"
    >
      <li
        v-for="(lpu, i) in context.doctor_practice.from_lpus"
        :key="i"
        class="d-flex ga-1 align-start"
        data-qa="lpu_partners_item"
      >
        {{ lpu }}
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { useContextStore } from 'src/store'
import type { ContextStore } from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/types'

const { context }: ContextStore = useContextStore()
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.lpu-partners {
  &__list {
    list-style: none;
  }

  &__list li::before {
    content: '•';
    flex-shrink: 0;
    color: $ui-kit-text-info;
    font-size: 16px;
    line-height: 1.25;
  }
}
</style>
